module.exports = __webpack_public_path__ + "static/img/popup_img.27a9805.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home/popup_img.png
// module id = vWzo
// module chunks = 1